/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_CreditsInputs */

const en_settings_billing_credits = /** @type {(inputs: Settings_Billing_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Settings_Billing_CreditsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_credits = /** @type {((inputs?: Settings_Billing_CreditsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_CreditsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_credits(inputs)
});
export { settings_billing_credits as "settings.billing.credits" }